import type { Footer } from 'root/client/components/footer/footer.types';
import type { Header } from 'root/client/components/header/header.types';
import type { MessageList } from 'root/client/components/message-list/message-list.types';

export enum Theme {
  Primary = 'primary',
}

export type Layout = {
  footer?: Footer;
  header: Header;
  kindlyChatKey?: string;
  messageList: MessageList;
  theme?: Theme;
};
